export enum ReminderStatus{
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED",
    CANCELLED = "CANCELLED",
    COMPLETED = "COMPLETED"
}